
import { Routes } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { CabanaYpeComponent } from './pages/cabana-ype/cabana-ype.component';
import { ChaleSantoriniComponent } from './pages/chale-santorini/chale-santorini.component';

import { CheckoutHospedesComponent } from './pages/checkout/checkout-hospedes/checkout-hospedes.component';
import { CheckoutPagamentoComponent } from './pages/checkout/checkout-pagamento/checkout-pagamento.component';
import { CheckoutCartaoComponent } from './pages/checkout/checkout-cartao/checkout-cartao.component';
import { CheckoutPixComponent } from './pages/checkout/checkout-pix/checkout-pix.component';
import { CheckoutPixPagamentoComponent } from './pages/checkout/checkout-pix-pagamento/checkout-pix-pagamento.component';
import { CheckoutSucessoComponent } from './pages/checkout/checkout-sucesso/checkout-sucesso.component';
import { NovaReservaComponent } from './pages/admin/nova-reserva/nova-reserva.component';

import { DashboardComponent } from './pages/admin/dashboard/dashboard.component';
import { QuartosComponent } from './pages/admin/quartos/quartos.component';
import { ReservasComponent } from './pages/admin/reservas/reservas.component';

import { LoginComponent } from './pages/admin/login/login.component';
import { AdminLayoutComponent } from './pages/admin/admin-layout/admin-layout.component';

import { adminAuthGuard } from './service/AdminAuthGuard';
import {AvaliacaoComponent} from './pages/avaliacao/avaliacao.component';
import {CuponsComponent} from './pages/admin/cupons/cupons.component';
import {PacotesComponent} from './pages/admin/pacotes/pacotes.component';
import {CheckoutPacotesComponent} from './pages/checkout/checkout-pacotes/checkout-pacotes.component';
import {TarifasDataComponent} from './pages/admin/tarifas-data/tarifas-data.component';
import {DisponibilidadeMesesComponent} from './pages/admin/disponibilidade-meses/disponibilidade-meses.component';
import {RegrasMinimoNoitesComponent} from './pages/admin/regras-minimo-noites/regras-minimo-noites.component';
import {SplitPagamentosComponent} from './pages/admin/split-pagamentos/split-pagamentos.component';


export const routes: Routes = [

  {
    path: '',
    component: HomeComponent
  },

  {
    path: 'cabana-ype',
    component: CabanaYpeComponent
  },

  {
    path: 'chale-santorini',
    component: ChaleSantoriniComponent
  },

  {
    path: 'avaliar/:token',
    component: AvaliacaoComponent
  },

  {
    path: 'checkout/hospedes',
    component: CheckoutHospedesComponent
  },

  {
    path: 'checkout/pacotes',
    component: CheckoutPacotesComponent
  },

  {
    path: 'checkout/pagamento',
    component: CheckoutPagamentoComponent
  },

  {
    path: 'checkout/cartao',
    component: CheckoutCartaoComponent
  },

  {
    path: 'checkout/pix',
    component: CheckoutPixComponent
  },


  {
    path: 'checkout/pix/pagamento',
    component: CheckoutPixPagamentoComponent
  },

  {
    path: 'checkout/sucesso',
    component: CheckoutSucessoComponent
  },

  {
    path: 'admin',

    children: [

      {
        path: 'login',
        component: LoginComponent
      },

      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login'
      },

      {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [adminAuthGuard],

        children: [

          {
            path: 'dashboard',
            component: DashboardComponent
          },

          {
            path: 'quartos',
            component: QuartosComponent
          },

          {
            path: 'reservas',
            component: ReservasComponent
          },

          {
            path: 'cupons',
            component: CuponsComponent
          },

          {
            path: 'pacotes',
            component: PacotesComponent
          },

          {
            path: 'tarifas-data',
            component: TarifasDataComponent
          },
          {
            path: 'criar-reserva',
            component: NovaReservaComponent
          },
          {
            path: 'disponibilidade-meses',
            component: DisponibilidadeMesesComponent
          },
          {
            path: 'regras-minimo-noites',
            component: RegrasMinimoNoitesComponent
          },
          {
            path: 'split-pagamentos',
            component: SplitPagamentosComponent
          }

        ]

      }

    ]

  },

  {
    path: '**',
    redirectTo: ''
  }

];
